(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * Provides an interface to the Watershed API which is necessarily aware
   * of the current user and organization.
   */
  factory('Api', ['User', 'Config', 'ShareUtils', function (User, Config, ShareUtils) {
    return {
      url: function url(relativePart, skipTenantPrefix, sharePath) {
        relativePart = relativePart || "";
        var wsConfig = Config.get();
        var root = wsConfig.apiUrl;
        var currentUser = User.get();

        // If this already starts with the root api url, it doesn't need decorated...
        if (relativePart.indexOf(root) === 0) {
          return relativePart;
        }
        if (ShareUtils.getCachedShare() && sharePath) {
          root = root + "/shared/" + ShareUtils.getShareKey();
        }
        if (skipTenantPrefix !== true && ShareUtils.getCachedShare()) {
          root = root + "/organizations/" + ShareUtils.getCachedShare().card.organization.id;
        } else if (currentUser !== null && typeof currentUser.organization !== "undefined" && skipTenantPrefix !== true) {
          root = root + "/organizations/" + currentUser.organization.id;
        }
        if (root[root.length - 1] !== '/' && (relativePart.length === 0 || relativePart[0] !== '/')) {
          root += '/';
        }
        return root + relativePart;
      }
    };
  }]);
})();
